module.exports = __webpack_public_path__ + "img/chickenwings.b75a80aa.jpg";